import type { AxiosResponse } from 'axios';
import axios from 'axios';

export const requestWithTimeout = async <T>(url: string, timeout = 60000): Promise<T> => {
  const response = await Promise.race([
    axios({
      method: 'get',
      url,
      timeout,
      validateStatus: (_) => true,
    }),
    new Promise<AxiosResponse>((_, reject) =>
      setTimeout(() => reject(`Timeout for request to ${url.toString()}`), timeout),
    ),
  ]);

  if (response.status !== 200) {
    throw new Error(`${response.status}: ${JSON.stringify(response.data)}`);
  }

  return response.data;
};
